import { render } from "./EmployeeList.vue?vue&type=template&id=3823022d&scoped=true"
import script from "./EmployeeList.vue?vue&type=script&lang=js"
export * from "./EmployeeList.vue?vue&type=script&lang=js"

import "./EmployeeList.vue?vue&type=style&index=0&id=3823022d&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3823022d"]])

export default __exports__